import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";

export interface LockedFeatureProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  description: string;
  backdrop?: ReactNode;
  action?: ReactNode;
  compact?: boolean;
}

/** Shared unavailable-feature surface with built-in hierarchy and spacing. */
export function LockedFeature({ title, description, backdrop, action, compact = false, className, ...props }: LockedFeatureProps) {
  return (
    <div className={cx("pz-lockedfeature", compact && "pz-lockedfeature--compact", className)} {...props}>
      {backdrop ? <div className="pz-lockedfeature__backdrop" aria-hidden>{backdrop}</div> : null}
      <div className="pz-lockedfeature__content">
        <p className="pz-lockedfeature__title">{title}</p>
        <p className="pz-lockedfeature__description">{description}</p>
        {action ? <div className="pz-lockedfeature__action">{action}</div> : null}
      </div>
    </div>
  );
}
